import actions from "./actions";

const initState = {
    pricingTransitionReadState: null,
    pricingTransitionReadData: {},

    pricingTransitionUpdateState: null,
    pricingTransitionUpdateData: {},

    publicPlansReadState: null,
    publicPlans: [],

    publicAddonPacksReadState: null,
    publicAddonPacks: [],
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.PUBLIC_READ_PRICING_TRANSITION_REQUEST:
            return {
                ...state,
                pricingTransitionReadState: 'request',
            };

        case actions.PUBLIC_READ_PRICING_TRANSITION_SUCCESS:
            return {
                ...state,
                pricingTransitionReadState: 'success',
                pricingTransitionReadData: action.pricingTransition,
            };

        case actions.PUBLIC_READ_PRICING_TRANSITION_ERROR:
            return {
                ...state,
                pricingTransitionReadState: 'error',
            };

        case actions.PUBLIC_UPDATE_PRICING_TRANSITION_REQUEST:
            return {
                ...state,
                pricingTransitionUpdateState: 'request',
            };

        case actions.PUBLIC_UPDATE_PRICING_TRANSITION_SUCCESS:
            return {
                ...state,
                pricingTransitionUpdateState: 'success',
                pricingTransitionUpdateData: action.pricingTransition,
            };

        case actions.PUBLIC_UPDATE_PRICING_TRANSITION_ERROR:
            return {
                ...state,
                pricingTransitionUpdateState: 'error',
            };

        case actions.PUBLIC_READ_PUBLIC_PLANS_REQUEST:
            return {
                ...state,
                publicPlansReadState: 'request',
            };
        case actions.PUBLIC_READ_PUBLIC_PLANS_SUCCESS:
            return {
                ...state,
                publicPlansReadState: 'success',
                publicPlans: action.plans,
            };
        case actions.PUBLIC_READ_PUBLIC_PLANS_ERROR:
            return {
                ...state,
                publicPlansReadState: 'error',
            };

        // New: Public Addons Packs
        case actions.PUBLIC_READ_PUBLIC_ADDONS_PACKS_REQUEST:
            return {
                ...state,
                publicAddonPacksReadState: 'request',
            };
        case actions.PUBLIC_READ_PUBLIC_ADDONS_PACKS_SUCCESS:
            return {
                ...state,
                publicAddonPacksReadState: 'success',
                publicAddonPacks: action.addonPacks,
            };
        case actions.PUBLIC_READ_PUBLIC_ADDONS_PACKS_ERROR:
            return {
                ...state,
                publicAddonPacksReadState: 'error',
            };

        default:
            return state;
    }
}
